module.exports = __webpack_public_path__ + "img/consultar.0ecbdf01.svg";